import { render, staticRenderFns } from "./index_m.vue?vue&type=template&id=f940b298&"
import script from "./index_m.vue?vue&type=script&lang=js&"
export * from "./index_m.vue?vue&type=script&lang=js&"
import style0 from "./index_m.vue?vue&type=style&index=0&id=f940b298&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports